import { HighlightButton } from '../HighlightButton/HighlightButton';

export default function Commissions() {
  const openForm = (url) => {
    window.open(url, "_blank", "noopener,noreferrer")
  }

  return (
    <main className="mainContainer centeredVertically">
      <h1>COMMISSIONS</h1>

      <section style={{ paddingBottom: "2rem" }}>
        <p>You can commission a custom arrangement, transcription, or composition from me. A finished commission includes:</p>

        <div style={{ paddingTop: "1rem", paddingBottom: "2rem" }}>
          <ul>
            <li>A PDF file of the completed full score</li>
            <li>An audio file of the score&apos;s digital playback</li>
            <li>Carefully notated guidelines for phrasing, breaths, articulations, and dynamics</li>
          </ul>
        </div>

        <div className="buttonContainer">
          <HighlightButton aria-label="Request commission (opens in new tab)" onClick={() => openForm("https://forms.gle/WPq1pP426AdhPrjt6")}>REQUEST A COMMISSION</HighlightButton>
        </div>

        {/* <p>If you have questions about commissioning a request due to the length of the piece or number of parts, please contact me and ask for a quote. I'm excited to work with you to create something great!</p> */}
      </section>
    </main>
  );
}